module.exports = __webpack_public_path__ + "img/calendar_icon.943022d7.svg";